module.exports = __webpack_public_path__ + "img/23.6ee1bd8a.png";